import React, { useState } from 'react';
import Menu, { TriggerProps } from '../../../shared/Menu/Menu';
import MenuItem from '../../../shared/Menu/MenuItem';
import exportIcon from '../../../../static/icons/download.svg';
import pdfIcon from '../../../../static/icons/documentsType/pdf.svg';
import excelIcon from '../../../../static/icons/documentsType/excel.svg';
import Button from '../../../shared/SmallComponents/Button';
import { exportTypes } from '../../../../state/ducks/allShipmentsPage/allShipmentsPage';
import { businessPartner } from '../../../../models/entities/businessPartner/businessPartner';
import { ColumnType } from '../../../shared/Grid/types/Column';
import ArrayToExcelModal from '../../../shared/ArrayToExcel/ArrayToExcelModal';
import { pickBy } from 'lodash';
import { ModalTriggerProps } from '../../../shared/Modal/Modal';
import Tooltip from '@mui/material/Tooltip';
import { connect } from 'react-redux';
import { usersSelectors } from '../../../../state/ducks/users/selectors';
import { RootState } from '../../../../state/store/store';

type Props = {
    companies: Array<businessPartner>;
    gridColumns: Array<ColumnType<businessPartner>>;
    localization: any;
    exportDataTable: (type: exportTypes) => void;
    getUserById: (id: string) => any;
};
const ExportMenuComponent = ({ localization, exportDataTable, gridColumns, companies, getUserById }: Props) => {
    const [isModalOpened, setIsModalOpened] = useState(false);

    // Transform salesman UUIDs to names for export
    const transformSalesmanData = (companies: Array<businessPartner>): Array<businessPartner> => {
        return companies.map((company) => {
            const filteredCompany = pickBy(company, (value, key) => 
                gridColumns.map((c) => c.field).includes(key as keyof businessPartner)
            ) as businessPartner;

            // Transform salesman field if it exists and has a value
            if (filteredCompany.salesman && 
                typeof filteredCompany.salesman === 'string' && 
                filteredCompany.salesman.trim() !== '' &&
                filteredCompany.salesman !== 'NaN') {
                
                const userIds = filteredCompany.salesman.split(',').map(id => id.trim()).filter(Boolean);
                const userNames = userIds
                    .map(userId => {
                        const user = getUserById(userId);
                        return user?.name;
                    })
                    .filter(Boolean); // Filter out undefined/null names
                
                // Replace UUID(s) with name(s)
                filteredCompany.salesman = userNames.length > 0 ? userNames.join(', ') : '-';
            }

            // Transform operationsManager field if it exists and has a value
            if (filteredCompany.operationsManager && 
                typeof filteredCompany.operationsManager === 'string' && 
                filteredCompany.operationsManager.trim() !== '' &&
                filteredCompany.operationsManager !== 'NaN') {
                
                const userIds = filteredCompany.operationsManager.split(',').map(id => id.trim()).filter(Boolean);
                const userNames = userIds
                    .map(userId => {
                        const user = getUserById(userId);
                        return user?.name;
                    })
                    .filter(Boolean); // Filter out undefined/null names
                
                // Replace UUID(s) with name(s)
                filteredCompany.operationsManager = userNames.length > 0 ? userNames.join(', ') : '-';
            }

            // Transform createdBy field if it exists and has a value
            if (filteredCompany.createdBy && 
                typeof filteredCompany.createdBy === 'string' && 
                filteredCompany.createdBy.trim() !== '' &&
                filteredCompany.createdBy !== 'NaN') {
                
                const user = getUserById(filteredCompany.createdBy);
                filteredCompany.createdBy = user?.name || '-';
            }

            // Transform updatedBy field if it exists and has a value
            if (filteredCompany.updatedBy && 
                typeof filteredCompany.updatedBy === 'string' && 
                filteredCompany.updatedBy.trim() !== '' &&
                filteredCompany.updatedBy !== 'NaN') {
                
                const user = getUserById(filteredCompany.updatedBy);
                filteredCompany.updatedBy = user?.name || '-';
            }

            return filteredCompany;
        });
    };

    const menuItems = [
        <ArrayToExcelModal<businessPartner>
            key="excel-export-modal"
            localization={{ ...localization.grid.columns, ...localization.exportOptions.export_excel_modal }}
            data={transformSalesmanData(companies)}
            title={localization.exportOptions.export_excel_modal.title}
            fileName={localization.exportOptions.export_file_name}
            onCancelCallback={() => {
                setIsModalOpened(false);
            }}
            Trigger={(props: ModalTriggerProps) => (
                <MenuItem
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsModalOpened(true);
                        props.onClick();
                    }}
                    icon={excelIcon}
                    text={localization.exportOptions.excel}
                />
            )}
        />
    ];
    return (
        <Menu
            position="bottom-center"
            arrowOnTrigger={false}
            options={menuItems}
            isModalOpened={isModalOpened}
            MenuTrigger={(props: TriggerProps) => (
                <Button width="32px" height="32px" borderRadius="50%" margin="7px" buttonType="hollow" onClick={props.onClick}>
                    <Tooltip title={localization.export_btn} aria-label="export">
                        <span className="material-icons-outlined">file_download</span>
                    </Tooltip>
                </Button>
            )}
        />
    );
};


const mapStateToProps = (state: RootState) => ({
    getUserById: (id: string) => usersSelectors.getUserById(state)(id)
});

const ExportMenu = connect(mapStateToProps)(ExportMenuComponent);

export default ExportMenu;
